import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { truncateText } from 'dpl/shared/utils';

export default class TruncatedMultiLineText extends Component {
  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    length: PropTypes.number.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    text: PropTypes.string,
    moreText: PropTypes.string,
    lessText: PropTypes.string,
    moreButtonClassName: PropTypes.string,
    setInnerHTML: PropTypes.bool, // directly set innerHTML (for encoded entities :/)
    isOpen: PropTypes.bool // if non-null, don't render the show/hide button (parent handles it)
  };

  static defaultProps = {
    text: '',
    moreText: 'Read More +',
    lessText: 'Show Less',
    moreButtonClassName: null,
    setInnerHTML: false,
    isOpen: null
  };

  state = {
    isOpen: false
  };

  handleClick = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const {
      moreText,
      lessText,
      setInnerHTML,
      isOpen: propsIsOpen,
      length,
      text
    } = this.props;

    let { isOpen } = this.state;
    if (typeof propsIsOpen === 'boolean') {
      isOpen = propsIsOpen;
    }

    const originalText = text.trim();
    const truncatedContent = truncateText(text, length);
    const displayedContent = isOpen ? originalText : truncatedContent;

    return (
      <div className="TruncatedMultiLineText">
        {setInnerHTML ? (
          /* eslint-disable-next-line react/no-danger */
          <p dangerouslySetInnerHTML={{ __html: displayedContent }} />
        ) : (
          <p>{displayedContent}</p>
        )}
        {typeof propsIsOpen !== 'boolean' &&
          truncatedContent.length !== originalText.length && (
            <button
              onClick={this.handleClick}
              type="button"
              className={classnames(
                'link--primary',
                this.props.moreButtonClassName
              )}
            >
              {isOpen ? lessText : moreText}
            </button>
          )}
      </div>
    );
  }
}
